import { IUserPreferences } from "../@types/Preferences";
import { AUTH_UNIT_PREFERENCES } from "../constants/localStorageKeys";
import { safeJsonParse, safeStorage } from "./storage";

/**
 * The raw language tag this session was opened with: the `language` query parameter on a mobile
 * webview URL, else the signed-in user's stored preference. `undefined` means the user has made
 * no choice, which is a different thing from having chosen English.
 *
 * It lives here, on its own, because both `config/i18n` (to seed the detector) and
 * `services/api` (to decide whether to send Accept-Language) need it, and api cannot import
 * config/i18n without closing the cycle config/i18n -> languageUtils -> translationsService ->
 * api. Nothing but storage and constants is imported here, so it stays safe to reach from
 * anywhere.
 */
export const readRequestedLanguage = (): string | undefined => {
  const fromUrl = new URLSearchParams(window.location.search).get("language");

  if (fromUrl) return fromUrl;

  // safeJsonParse, not JSON.parse: this runs on the login path (AuthContext calls
  // applyStoredLanguage once the preferences land), and a corrupt value here must not be able
  // to throw into the middle of session setup.
  const preferences = safeJsonParse<IUserPreferences | undefined>(
    safeStorage.getItem(AUTH_UNIT_PREFERENCES),
    undefined
  );

  return preferences?.languageCode ?? undefined;
};
